import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/_services/notification.service';
import { TokenStorageService } from 'src/app/_services/token-storage.service';
import { UserService } from 'src/app/_services/user.service';

@Component({
  selector: 'app-confirm-otp-dialog',
  templateUrl: './confirm-otp-dialog.component.html',
  styleUrls: ['./confirm-otp-dialog.component.scss']
})
export class ConfirmOtpDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConfirmOtpDialogComponent>
    ,@Inject(MAT_DIALOG_DATA) public data: any,
     private userService: UserService,
     private token: TokenStorageService,
     private _notificationSvc: NotificationService,
     private translate: TranslateService
  ) { }
  form: FormGroup = new FormGroup( {
    codigoSeguridad: new FormControl("", [Validators.required, Validators.pattern("[0-9]{6}")])
  }, {});
  otpGenerada :boolean= false;
  tipo: string = '';
  ngOnInit(): void {
   this.openGenerateOtp()
  }
  finish(){   
    this.validarCodigoSeguridad();
  }

  cancel(){
    this.dialogRef.close({result:'Cancelar'});
  }
  validarCodigoSeguridad(): Boolean{
    var retorno:Boolean = false;
    this.userService.validarCodigoSeguridad(this.token, this.form.value.codigoSeguridad).subscribe({
      next: data => {
        if (data.status === "653") {
          this._notificationSvc.success(
            this.translate.instant('COMMON.DONE'),
            this.translate.instant('MODAL.OTP_VALID'),
            50000
          );
          this.dialogRef.close({result: 'Confirmar'});
        }
        else{
          this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), data.message, 50000);
          if (data.status === "656") {
            setTimeout(() => {this.logout();}, 5000);
          }
        }
      },
      error: (err) => {
          this._notificationSvc.error(
            this.translate.instant('COMMON.ERROR'),
            this.translate.instant('MODAL.OTP_VALIDATE_FAIL'),
            50000
          );
      }
    });
    return retorno;
  }
  logout(): void {
    this.token.signOut();
    window.location.reload();
  } 

  
  openGenerateOtp(){
    var retorno:Boolean = false;
    this.userService.generarCodigoSeguridad(this.token, this.data.tipo).subscribe({
      next: data => {
        if (data.status === "652") {

          this._notificationSvc.success(
            this.translate.instant('COMMON.DONE'),
            this.translate.instant(this.data.tipo == 'MOVIL' ? 'MODAL.OTP_SENT_MOBILE' : 'MODAL.OTP_SENT_EMAIL'),
            50000
          );
          this.otpGenerada = true;
        }
        else{
          this.otpGenerada  = false;
        }
      },
      error: (err) => {
          this._notificationSvc.error(
            this.translate.instant('COMMON.ERROR'),
            this.translate.instant(this.data.tipo == 'MOVIL' ? 'MODAL.OTP_SEND_FAIL_MOBILE' : 'MODAL.OTP_SEND_FAIL_EMAIL'),
            50000
          );
          this.otpGenerada  = false;
          this.dialogRef.close({result:'Cancelar'});
      }
    });
  }
}
